import React from "react";

const GROUPS = [
  { key: "functionality", label: "Functionality", chipClass: "softwareToolChipFunc" },
  { key: "dataSources", label: "Data sources", chipClass: "softwareToolChipSource" },
  { key: "languages", label: "Languages", chipClass: "softwareToolChipLang" },
];

/**
 * The three labelled chip groups shown for one HSSI software tool.
 * Groups with no values are omitted. Chips are plain text, not controls.
 *
 * @param props.functionality Array of functionality category names.
 * @param props.dataSources Array of data source names.
 * @param props.languages Array of programming language names.
 * @param props.stacked When true, labels sit above their chips and each group
 * is wrapped in its own element so the groups can be spaced equally.
 * @param props.className Optional extra class appended to the root element.
 * @return JSX or null
 */
export function SoftwareToolChips({ functionality = [], dataSources = [], languages = [], stacked = false, className: extraClassName }) {
  const values = { functionality, dataSources, languages };
  const groups = GROUPS.filter(({ key }) => values[key] && values[key].length > 0);
  if (groups.length === 0) {
    return null;
  }
  const className = [
    "softwareToolSpecs",
    stacked && "softwareToolSpecsStacked",
    extraClassName,
  ].filter(Boolean).join(" ");
  const Group = stacked
    ? ({ children }) => <div className="softwareToolSpecGroup">{children}</div>
    : React.Fragment;
  return (
    <div className={className}>
      {groups.map(({ key, label, chipClass }) => (
        <Group key={key}>
          <div className="softwareToolSpecLabel">{label}</div>
          <ul className="softwareToolChips" aria-label={label}>
            {values[key].map((value) => (
              <li key={value} className={`softwareToolChip ${chipClass}`}>{value}</li>
            ))}
          </ul>
        </Group>
      ))}
    </div>
  );
}
